import React from 'react';
import { WebSite, WithContext } from 'schema-dts';

import Head from 'components/Head';

import Footer from 'ux/Layouts/Shared/Footer';

import './Home.scss';

import CustomersTestimonialsSection from './CustomersTestimonialsSection';
import HeroRedesign from './HeroRedesign';
import HomeKpiSection from './HomeKpiSection';
import HomeMarqueeSection from './HomeMarqueeSection';
import DayOne from './DayOne/DayOne';
import Requests from './Requests/Requests';
import Services from './Services/Services';
import WhyCodiSection from './WhyCodiSection';

interface Props {}

const HOME_META_TITLE = 'Codi AI Office Management Solution | Cleaning, Pantry & More';
const HOME_META_DESCRIPTION =
  'Automate office setup & logistics: cleaning, furniture, IT, pantry & more, all managed in one place. Cut costs by up to 83% and save hundreds of hours.';

const Home: React.FC<Props> = () => {
  const schema: WithContext<WebSite> = {
    '@context': 'https://schema.org',
    '@id': `${window.location.origin}/#website`,
    '@type': 'WebSite',
    name: 'Codi',
    url: window.location.origin,
    description: HOME_META_DESCRIPTION,
    hasPart: {
      '@type': 'WebPage',
      speakable: { '@type': 'SpeakableSpecification', xpath: ["/html/head/meta[@name='description']/@content"] },
      significantLink: `${window.location.origin}/request-services`
    },
    publisher: {
      '@type': 'Corporation',
      name: 'Codi',
      legalName: 'Codi Inc.',
      logo: 'https://ik.imagekit.io/r2atwkj92wo/public/Codi-logo_icb15iqnP.png',
      image: 'https://ik.imagekit.io/r2atwkj92wo/public/tr:w-600/e6a421371e38c8d343831983605f0629_yu9zLLeag.jpeg',
      sameAs: [
        'https://www.linkedin.com/company/codiwork',
        'https://twitter.com/codiwork',
        'https://www.facebook.com/codicommunity',
        'https://www.instagram.com/codiwork/',
        'https://www.crunchbase.com/organization/codi-2000'
      ],
      brand: {
        '@type': 'Brand',
        name: 'Codi'
      },
      funder: [
        {
          '@type': 'Corporation',
          '@id': 'https://a16z.com/',
          legalName: 'AH Capital Management, LLC',
          name: 'Andreessen Horowitz',
          url: 'https://a16z.com/',
          sameAs: 'https://en.wikipedia.org/wiki/Andreessen_Horowitz'
        }
      ]
    }
  };

  return (
    <>
      <Head title={HOME_META_TITLE} description={HOME_META_DESCRIPTION} />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <div className="HomeV10">
        <HeroRedesign />
        <HomeMarqueeSection />
        <HomeKpiSection />
        <div id="services">
          <Services />
        </div>
        <div id="requests">
          <Requests />
        </div>
        <DayOne />
        <div id="customers">
          <CustomersTestimonialsSection />
        </div>
        <div id="pricing">
          <WhyCodiSection />
        </div>
      </div>
      <Footer hasMargin={false} />
    </>
  );
};

export default Home;
